// Reads the assistant's reply from POST /api/agent: the AI SDK's UI message
// stream, which is server-sent events — one `data: {json}` per event, ending
// with `data: [DONE]`. A small reader instead of @ai-sdk/react: the chat only
// needs the text and the tool results, and CRA 5 stays free of the SDK's ESM
// build.
//
// Events used: text-delta { delta }, tool-output-available { toolCallId,
// output }, tool-input-available { toolCallId, toolName }, error { errorText }.
// Everything else (start, steps, finish) is ignored.

export async function readAgentStream(response, onEvent) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  const handle = (block) => {
    const data = block
      .split("\n")
      .filter((line) => line.startsWith("data:"))
      .map((line) => line.slice(5).trimStart())
      .join("\n");
    if (!data || data === "[DONE]") return;
    try {
      onEvent(JSON.parse(data));
    } catch (error) {
      console.error("Agent stream: unreadable event", error);
    }
  };

  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true }).replace(/\r\n/g, "\n");
    let end = buffer.indexOf("\n\n");
    while (end !== -1) {
      handle(buffer.slice(0, end));
      buffer = buffer.slice(end + 2);
      end = buffer.indexOf("\n\n");
    }
  }
  if (buffer.trim()) handle(buffer);
}
